module.exports = __webpack_public_path__ + "img/dashboard-hero@2x.997f13e9.jpg";